import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "selector", "businessCard", "companyName", "howHeardOther" ]

  connect() {
    let initialServiceSelection = $(this.selectorTarget).find('input:checked').attr('data-service-type')
    this.serviceSelection = initialServiceSelection
  }

  selectServiceType(event) {
    let serviceSelection = event.target.getAttribute('data-service-type');
    this.serviceSelection = serviceSelection
  }

  get serviceSelection() {
    return this.data.get('selectedService')
  }

  set serviceSelection(serviceSelection) {
    this.data.set('selectedService', serviceSelection)

    if (serviceSelection == 'residential') {
      $(this.businessCardTarget).hide()
      $(this.companyNameTarget).prop('required', false)

    } else if (serviceSelection == 'commercial') {
      $(this.businessCardTarget).show()
      $(this.companyNameTarget).prop('required', true)
    }
  }

  selectHowHeard(event){
    const target = event.target
    const value = $(target).val()
    let otherKeys = []
    try {
      otherKeys = JSON.parse(target.dataset.otherKeys || '[]')
    } catch (_e) {
      otherKeys = []
    }
    if (!Array.isArray(otherKeys) || otherKeys.length === 0) {
      otherKeys = ['other']
    }
    const isOther = otherKeys.includes(value)
    $(this.howHeardOtherTarget).toggle(isOther)
    $(this.howHeardOtherTarget).find('input').attr('required', isOther)
    if(!isOther){
      $(this.howHeardOtherTarget).find('input').val('')
    }
  }
}
